import angular from 'angular';

import { TypeaheadComponent } from './typeahead.component';

const MODULE_NAME = 'core.components.typeahead';

angular.module('core.components.typeahead', []).component('esTypeahead', TypeaheadComponent);

export default MODULE_NAME;
